export enum EventType {
	BESTFIT_OVERVIEW_READY = 'BestfitOverviewReady',
	BESTFIT_RECALCULATED = 'BestfitRecalculated',
	BESTFIT_MODIFY_ANSWER = 'BestfitModifyAnswer',
}
